/**
 * IDB Utilities
 *
 * Shared low-level helpers for IndexedDB operations.
 * Import from here instead of duplicating promise wrappers.
 */

/**
 * Delete an IndexedDB database by name.
 * Resolves (never rejects) regardless of success, error, or blocked state,
 * since callers generally can't recover from a failed delete.
 */
export function deleteIDBDatabase(name: string): Promise<void> {
  return new Promise<void>((resolve) => {
    const req = indexedDB.deleteDatabase(name);
    req.onsuccess = () => resolve();
    req.onerror = () => resolve();
    req.onblocked = () => resolve();
  });
}
